/**
 * Optimized Admin Doubts Management with Pagination and Caching
 */

import AdminDoubtsManagement from './AdminDoubtsManagement';
import withOptimization from '../../hoc/withOptimization';

export default withOptimization(AdminDoubtsManagement, {
  collection: 'doubts',
  pageSize: 30,
  orderByField: 'createdAt',
  orderDirection: 'desc',
  cacheTTL: 3 * 60 * 1000
});

/**
 * Performance Improvements:
 * - Before: Loads ALL doubts (1000+) = 10-15s load time
 * - After: Loads 30 doubts at a time = 2-3s load time
 * - Firestore reads: 1000+ → 30-150
 */
